<h2 mat-dialog-title>Repetir</h2>
<br>
<mat-dialog-content class="dialog-content" [formGroup]="form">
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Iniciar</mat-label>
    <input matInput [matDatepicker]="picker" formControlName="startDate">
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>

  <div class="repeat-options">
    <span>Repetir cada</span>
    <mat-form-field appearance="outline" class="number-field">
      <input matInput type="number" min="1" formControlName="repeatEvery">
    </mat-form-field>
    <mat-form-field appearance="outline" class="unit-field">
      <mat-select formControlName="repeatUnit">
        <mat-option value="dia">día</mat-option>
        <mat-option value="semana">semana</mat-option>
        <mat-option value="mes">mes</mat-option>
        <mat-option value="ano">año</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="days-container">
    <ng-container *ngFor="let day of daysOfWeek">
      <button mat-button [color]="isSelected(day.value) ? 'warn' : undefined" (click)="toggleDay(day.value)">
        {{ day.label }}
      </button>
    </ng-container>
  </div>



  <p>
    Tiene lugar cada
    {{ form.value.selectedDays.length ? form.value.selectedDays.join(', ') : 'día' }}
    hasta {{ form.value.endDate | date:'dd \'de\' MMMM \'de\' y' }}
  </p>

  <div *ngIf="form.value.endDate">
    <button mat-button color="warn" (click)="removeEndDate()">Quitar fecha de finalización</button>
  </div>

  <ng-container *ngIf="!form.value.endDate">
    <mat-form-field appearance="outline">
      <mat-label>Fecha de finalización</mat-label>
      <input matInput [matDatepicker]="endPicker" formControlName="endDate">
      <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
      <mat-datepicker #endPicker></mat-datepicker>
    </mat-form-field>
  </ng-container>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <app-button-cancel-dialog></app-button-cancel-dialog>
  <app-button-save (click)="save()"></app-button-save>
    <app-button-delete (click)="eliminar()" ></app-button-delete>
</mat-dialog-actions>
